







import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'ProductVideo',
  props: {
    src: {
      type: String,
      required: true,
    },
    mimeType: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    unsupportedVideoMessage: {
      type: String,
      default: 'Your browser does not support HTML5 video.',
    },
  },
});
